import { render, staticRenderFns } from "./KeyJudgment.vue?vue&type=template&id=e3616fea&scoped=true"
import script from "./KeyJudgment.vue?vue&type=script&lang=js"
export * from "./KeyJudgment.vue?vue&type=script&lang=js"
import style0 from "./KeyJudgment.vue?vue&type=style&index=0&id=e3616fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3616fea",
  null
  
)

export default component.exports